import { Singleton } from 'typescript-ioc';
import { createIntl, createIntlCache, IntlShape } from 'react-intl';
import { EN_US } from '../../constants/locales.constants';
import locales_EN_US from '../../../internals/locales/compiled-lang/en.json';
import { IReactIntlProvider } from '../react-intl-provider';

@Singleton
export class ReactIntlServiceProvider extends IReactIntlProvider {
    private static defaultLocale = EN_US;
    private intl: IntlShape;

    public initialize(locale: string, defaultLocale?: string): void {
        this.intl = createIntl({
            locale: locale,
            messages: locales_EN_US,
            defaultLocale: defaultLocale || ReactIntlServiceProvider.defaultLocale
        }, createIntlCache());
    }

    public getIntl(): IntlShape {
        if (!this.intl) throw new Error('Not initialized');

        return this.intl;
    }
}
